var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReorderIcon = function SvgReorderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14648 5.35355L6.00004 2.20711L2.85359 5.35355L2.14648 4.64645L5.64648 1.14645C5.84175 0.951184 6.15833 0.951184 6.35359 1.14645L9.85359 4.64645L9.14648 5.35355Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85361 6.64645L6.00005 9.79289L9.1465 6.64645L9.85361 7.35355L6.35361 10.8536C6.15834 11.0488 5.84176 11.0488 5.6465 10.8536L2.1465 7.35355L2.85361 6.64645Z",
    fill: "#767676"
  })));
};
export { SvgReorderIcon as ReactComponent };
export default __webpack_public_path__ + "assets/6f68c647.svg";